import { Bug, Lightbulb, HelpCircle, MessageSquare, Sparkles, Grid, Megaphone, Settings } from 'lucide-react';

interface DiscussionFiltersProps {
    selectedType: string;
    onTypeChange: (type: string) => void;
}

const DISCUSSION_TYPES = [
    { value: 'all', label: 'All', icon: Grid, color: 'purple' },
    { value: 'announcement', label: 'Announcements', icon: Megaphone, color: 'orange' },
    { value: 'bug', label: 'Bugs', icon: Bug, color: 'red' },
    { value: 'feature', label: 'Feature Requests', icon: Lightbulb, color: 'yellow' },
    { value: 'question', label: 'Questions', icon: HelpCircle, color: 'blue' },
    { value: 'feedback', label: 'Feedback', icon: MessageSquare, color: 'green' },
    { value: 'astrology', label: 'Astrology', icon: Sparkles, color: 'indigo' },
    { value: 'general', label: 'General', icon: MessageSquare, color: 'purple' },
];

const DiscussionFilters = ({ selectedType, onTypeChange }: DiscussionFiltersProps) => {
    return (
        <div className="w-full overflow-x-auto pb-2 custom-scrollbar">
            <div className="flex items-center gap-2 min-w-max px-1">
                {DISCUSSION_TYPES.map((type) => {
                    const Icon = type.icon;
                    const isSelected = selectedType === type.value;

                    return (
                        <button
                            key={type.value}
                            onClick={() => onTypeChange(type.value)}
                            className={`px-3 md:px-4 py-2 rounded-full font-sans font-bold text-xs transition-all flex items-center gap-1.5 whitespace-nowrap ${isSelected
                                ? `bg-${type.color}-500/20 text-${type.color}-300 border border-${type.color}-500/40`
                                : 'bg-white/[0.04] text-white/50 hover:bg-white/[0.08] hover:text-white border border-white/10'
                                }`}
                        >
                            <Icon size={14} className="shrink-0" />
                            <span>{type.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default DiscussionFilters;
